export default __webpack_public_path__ + "static/media/CustomQuiz.eb2fe4e3.webp";